import DayItem from "/components/shared/DayItem";
import VODItem from "/components/shared/VODItem";
import EventContext from '/context/EventContext.js';
import React, {useContext} from "react";
import {DateTime} from 'luxon';
import {flattenProductionsToShows, groupShowsByDay, groupShowsByMonth, filterVODShows} from '/utils';
import NoEventsView from "/components/shared/NoEventsView";


export default function NextShowsView({id, classIdentifier}) {
    const {event} = useContext(EventContext);
    if (!event.subevents.length) {
        return (
            <section className={classIdentifier} id={id}>
              <div className='pb-8 md:pb-24'>
                <div className='mt-8'>
                  <h1 className="mb-text-lg xl:text-xl text-gray-dark">
                    Nächste Vorstellungen
                  </h1>
                </div>
                <p className="pt-4">
                  Derzeit gibt es keine bevorstehenden Termine.
                </p>
              </div>
            </section>
        );
    }

    let shows = flattenProductionsToShows([event]);
    let vodShows = filterVODShows(shows);
    let showsGroupedByMonth = groupShowsByMonth(shows);

    const showViews = Object.entries(showsGroupedByMonth).map(([yearMonth, showsByMonth]) => {
        let showsGroupedByDay = groupShowsByDay(showsByMonth);
        let spl = yearMonth.split('-');
        let year = parseInt(spl[0]);
        let month = parseInt(spl[1]);
        return (
            <div>
              <h3 className="text-lg">{DateTime.local(year, month, 1).setLocale('de').toFormat('LLLL')}</h3>
              {
                  Object.entries(showsGroupedByDay).map(([day, showsByDay]) => {
                      return (
                          <DayItem
                            key={day}
                            day={DateTime.fromISO(day)}
                            shows={showsByDay}
                          />
                      );
                  })
              }
            </div>
        );
    });

    return (
        <section className={classIdentifier} id={id}>
          <div className='pb-8 md:pb-24'>
            <VODItem shows={vodShows} />
            <div className='mt-8'>
              <h1 className="mb-text-lg xl:text-xl text-gray-dark">
                Nächste Vorstellungen
              </h1>
            </div>
            <div className='h-fit m-2 xl:m-4'>{showViews}</div>
          </div>
        </section>
    );
}
